/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { keyResultSchema } from './keyResultSchema';
import { objectiveSchema } from './objectiveSchema';

export const objectiveWithKeyResultsSchema = z.object({
  id: z.int(),
  get keyResults() {
    return z.array(keyResultSchema);
  },
  get objective() {
    return objectiveSchema;
  },
});
